import {
  BOM_POSITION_ID,
  COMMUNITY_ID,
  END_DATE,
  FIRST_NAME,
  SEARCH_TYPE,
  SEARCH_CRITERIA,
  LAST_NAME,
  START_DATE,
  USER_IDS,
} from "./consts";
import { z } from "zod";

export const bomSchema = z.object({
  [SEARCH_TYPE]: z.string().optional(),
  [FIRST_NAME]: z.string().optional(),
  [LAST_NAME]: z.string().optional(),
  [SEARCH_CRITERIA]: z.string().optional(),
});

export type bomFormValues = z.infer<typeof bomSchema>;

export const addBomSchema = z.object({
  [BOM_POSITION_ID]: z.string().min(1, "BM Position is required"),
  [START_DATE]: z
    .union([z.string(), z.date()])
    .refine((val) => !isNaN(Date.parse(val.toString())), {
      message: "Invalid date format.",
    }),
  [END_DATE]: z
    .union([z.string(), z.date()])
    .refine((val) => !val || !isNaN(Date.parse(val.toString())), {
      message: "Invalid date format.",
    })
    .optional(),
  [USER_IDS]: z.string().optional(),
  [COMMUNITY_ID]: z.string().optional(),
});

export type addBomFormValues = z.infer<typeof addBomSchema>;
